<template>
  <div>
    <div>
      <span
        v-if="!input.visible"
        class="text-danger"
      >{{ $t('vendorManagmentInputView.istifadilrBuBlokuGrmrlr') }}</span>
      <div
        v-if="input.title"
        class="font-weight-bold"
      >
        {{ input.title }}
        <span
          v-if="input.required"
          class="text-danger"
        >*</span>
      </div>
      <div
        v-if="input.description"
        class="text-gray mb-2"
      >
        {{ input.description }}
      </div>
    </div>

    <div
      class="my-2"
      style="margin-top: auto"
    >
      <!-- Input Types -->
      <div v-if="input.inputType === 'string'">
        <input
          v-model="inputValue"
          type="text"
          class="form-control"
          :required="input.required"
        >
      </div>
      <div v-else-if="input.inputType === 'number'">
        <input
          v-model="inputValue"
          type="number"
          class="form-control"
          :required="input.required"
        >
      </div>
      <div v-else-if="input.inputType === 'longtext'">
        <textarea
          v-model="inputValue"
          rows="5"
          class="form-control"
          :required="input.required"
        />
      </div>
      <div v-else-if="input.inputType === 'email'">
        <input
          v-model="inputValue"
          type="email"
          class="form-control"
          :required="input.required"
          @input="event => event.target.setCustomValidity('')"
          @invalid="event => event.target.setCustomValidity('Düzgün email address yazın')"
        >
      </div>
      <div v-else-if="input.inputType === 'url'">
        <input
          v-model="inputValue"
          type="url"
          class="form-control"
          :required="input.required"
          placeholder="https://example.com/path"
          @input="event => event.target.setCustomValidity('')"
          @invalid="event => event.target.setCustomValidity('Düzgün link yazın')"
        >
      </div>
      <div v-else-if="input.inputType === 'phone'">
        <VuePhoneNumberInput
          v-model="phoneNumber"
          :default-country-code="'AZ'"
          :only-countries="['AZ']"
          :required="input.required"
          :no-example="true"
          @update="phoneUpdated($event)"
          @phone-number-blur="phoneBlur($event)"
        />
      </div>
      <div v-else-if="input.inputType === 'date'">
        <datepicker
          v-model="localDate"
          :name="`input_${input.id}`"
          :required="input.required"
          input-class="datepicker-here form-control digits"
          :format="dateFormat"
        />
        <span
          v-if="errorMessage"
          class="text-danger"
        >{{ errorMessage }}</span>
      </div>

      <div v-else-if="input.inputType ==='daterange'">
        <date-range-picker
          ref="picker"
          v-model="dateRange"
          class="w-100"
          opens="right"
          input-class="datepicker-here form-control digits"
          :ranges="false"
          :locale-data="{ firstDay: 1, format: 'dd-mm-yyyy' }"
          :time-picker="false"
          :linked-calendars="true"
          :auto-apply="true"
          :date-format="dateFormatDateRange"
          @update="dateRangeSelected($event)"
        >
          <template
            #input="picker"
            style="min-width: 350px;"
          >
            {{
              $t('vendorManagmentInputView.key', {
                moment: getMoment(picker.startDate),
                moment_2: getMoment(picker.endDate)
              })
            }}
          </template>
        </date-range-picker>
      </div>

      <div v-else-if="input.inputType ==='select'">
        <Multiselect
          v-model="selectedValue"
          :name="`input_${input.id}`"
          :options="selectValue"
          :multiple="configuration.multiple"
          :taggable="false"
          :allow-empty="!input.required"
          :aria-required="true"
          @blur="validateField"
        />

        <span
          v-if="errorMessage"
          class="text-danger"
        >{{ errorMessage }}</span>
      </div>
      <!-- Conditionally show file upload input if the selected option requires file upload -->
      <div
        v-if="selectedValue?.length>0 && configuration.allowFileUpload"
        class="mt-3"
      >
        <label for="comment">{{ $t('vendorManagmentInputView.commentPlaceholder') }}</label>
        <textarea
          id="comment"
          v-model="comment"
          rows="2"
          class="form-control"
          :placeholder="$t('vendorManagmentInputView.commentPlaceholder')"
        />
        <div
          v-if="selectedOptionRequiresFileUpload"
          class="text-danger mb-2"
        >
          {{ $t('vendorManagmentInputView.fileUploadRequired') }}
        </div>
      </div>
      <vue2Dropzone
        v-show="input.inputType === 'file' || selectedValue?.length>0 && configuration.allowFileUpload"
        id="dropzone"
        ref="fileDropzone"
        :options="uploadOptions"
        @vdropzone-sending="uploadEvent"
        @vdropzone-complete="fileAdded"
        @vdropzone-removed-file="fileRemoved"
      />
    </div>
    <div
      v-if="isAdmin"
      class="actions"
    >
      <a
        class="btn btn-sm btn-primary m-1 px-2"
        :title="$t('vendorManagmentInputView.blokuRedaktEt')"
        @click="$emit('edit')"
      >
        <feather
          type="edit-2"
          size="12"
        />
      </a>
      <a
        class="btn btn-sm btn-danger m-1 px-2"
        :title="$t('vendorManagmentInputView.blokuSil')"
        @click="$emit('delete')"
      >
        <feather
          type="x"
          size="12"
        />
      </a>
      <a
        class="btn btn-sm btn-success m-1 px-2"
        :title="$t('vendorManagmentInputView.buBlokuKopyala')"
        @click="$emit('copy')"
      >
        <feather
          type="copy"
          size="12"
        />
      </a>
      <a
        class="btn btn-sm btn-dark m-1 px-2"
        :title="$t('vendorManagmentInputView.buBlokdanSonraYeniBlokLavEt')"
        @click="$emit('addAfter')"
      >
        <feather
          type="plus"
          size="12"
        />
      </a>
    </div>
  </div>
</template>
<script>

import Multiselect from 'vue-multiselect';
import vue2Dropzone from 'vue2-dropzone';
import 'vue2-dropzone/dist/vue2Dropzone.min.css';
import Datepicker from 'vuejs-datepicker';
import VuePhoneNumberInput from 'vue-phone-number-input';
import 'vue-phone-number-input/dist/vue-phone-number-input.css';

import DateRangePicker from 'vue2-daterange-picker';
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css';

import {mapState} from 'vuex';
import {baseUrl, mediaBase} from '@/repositories/Repository';
import moment from 'moment';

export default {
  name: 'VendorManagementInputView',
  props: ['input', 'isAdmin', 'modelValue'],
  emits: ['update:modelValue', 'file-upload-status', 'option-changed'],
  data() {
    return {
      dateSetCount: 0,
      localDate: null,
      comment: '',
      selectedOptionRequiresFile: false,
      selectinVALUE: '',
      mediaBase: mediaBase,
      apiBase: baseUrl,
      configuration: {},
      dateFormat: 'dd/MM/yyyy',
      uploadedFiles: [],
      selectedValue: '',
      phoneNumber: '',
      phoneObject: null,
      dateRange: {
        startDate: null,
        endDate: null,
      },
      selectedOptionRequiresFileUpload: false,
      emailError: '',
      urlError: '',
      errorMessage: ''

    };
  },
  watch: {
    localDate(newDate) {
      if (this.input.inputType === 'date') {
        if (newDate) {
          this.$emit('update:modelValue', moment(newDate).format('DD/MM/YYYY'));
        } else {
          this.$emit('update:modelValue', '');
        }
      }
    },
    selectedValue(newVal) {
      this.errorMessage = ''; // Clear error on change
      this.updateModelValue();
    },
    uploadedFiles(newVal) {
      this.updateModelValue();
    },
    comment(newVal) {
      this.updateModelValue();
    },
    modelValue(newVal) {
      if (newVal) {
        this.syncLocalValues(newVal); // Extract and set local values
        this.processDropzoneFiles();
        this.checkModelValue()// Add files to Dropzone
      }
    },
  },
  computed: {
    ...mapState({
      token: (state) => state.auth.token,
    }),

    inputValue: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit('update:modelValue', value);
      },
    },
    uploadPath() {
      return `${baseUrl}/user/upload`;
    },
    uploadOptions() {
      return {   ////
        url: this.uploadPath,
        thumbnailHeight: 150,
        thumbnailWidth: 150,
        maxFilesize: 50,
        withCredentials: false,
        headers: {
          token: this.token,
          'Cache-Control': '',
          'X-Requested-With': '',
        },
        addRemoveLinks: true,
        dictDefaultMessage: "<i class='fa fa-cloud-upload'></i> <br> fayl yüklə",
        dictRemoveFile: 'sil',
        acceptedFiles: ""
      };
    },
    selectValue() {
      // Extract options for the select dropdown
      if (this.input.inputType === 'select') {
        return this.configuration.options.map((option) => option.text);
      }
      return [];
    },
  },
  created() {
    this.configuration = JSON.parse(this.input.settings);

  },
  mounted() {
    this.$nextTick(() => {
      const dropzoneInstance = this.$refs.fileDropzone?.dropzone;

      if (!dropzoneInstance) {
        console.warn('Dropzone is not ready during mounted. Will wait for modelValue update.');
        return;
      }
      if (this.modelValue) {
        this.syncLocalValues(this.modelValue); // Set initial local values\
        this.checkModelValue()
        this.processDropzoneFiles(); // Add files to Dropzone
      }
    });

  },
  methods: {
    validateField() {
      // Only check validation for select type when required
      if (this.input.inputType === 'select' && this.input.required) {
        if (!this.selectedValue || (Array.isArray(this.selectedValue) && this.selectedValue.length === 0)) {
          this.errorMessage = this.$t('This field is required');
          return false;
        }
      }

      // New check: if the selected option requires file upload, validate that a file was uploaded
      if (this.input.inputType==='file' && this.input.required ) {
        if ((!this.uploadedFiles || this.uploadedFiles.length === 0)){
          this.errorMessage = this.$t('vendorManagmentInputView.fileUploadRequired');
          return false;
        }
      }

      if (this.input.inputType === 'date' && this.input.required) {
        if (!this.localDate) {
          this.errorMessage = this.$t('dateRequired');
          return false;
        }
      }

      // Clear any error message if all validations pass
      this.errorMessage = '';
      return true;
    },
    processDropzoneFiles() {
      const dropzoneInstance = this.$refs.fileDropzone?.dropzone;

      if (!dropzoneInstance) {
        console.error('Dropzone instance is not available.');
        return;
      }

      const existingFileNames = dropzoneInstance.files.map((file) => file.name);
      if (this.uploadedFiles.length > existingFileNames) {
        this.uploadedFiles.forEach((filePath) => {
          const fileName = filePath.split('/').pop();
          if (!existingFileNames.includes(fileName)) {
            const fileUrl = `${this.mediaBase}${filePath}`;
            const fileExtension = filePath.split('.').pop().toLowerCase();
            const isImage = ['jpg', 'jpeg', 'png', 'gif'].includes(fileExtension);

            const mockFile = {
              name: filePath.split('/').pop(),
              size: 1000, // Mock size
              type: isImage ? `image/${fileExtension}` : `application/${fileExtension}`,
            };
            this.$emit('file-upload-status', {id: this.input.id, status: true});

            this.$refs.fileDropzone.manuallyAddFile(mockFile, fileUrl);

          }
        });
      }
    },
    updateModelValue() {
      if (this.input.inputType === 'select') {
        this.checkIfFileUploadIsRequired(this.selectedValue);
      }
      const filePart = this.uploadedFiles.length > 0 ? this.uploadedFiles.join(',') : '';
      const combinedValue = [
        this.selectedValue || '',
        this.comment || '',
        filePart,
      ]
          .filter(Boolean) // Remove empty parts
          .join('::::');

      this.$emit('update:modelValue', combinedValue.trim().replace(/:+$/, ''));
    },

    syncLocalValues(modelValue) {
      if (this.input.inputType !== 'select') {
        return;
      }

      const parts = modelValue.split('::::');
      let selectedValue = '';
      let comment = '';
      let files = '';

      if (parts.length === 3) {
        // Expected format: selectedValue, comment, files
        [selectedValue, comment, files] = parts;
      } else if (parts.length === 2) {
        // Check if the second part is a file (starts with '/vendorManagement')
        if (parts[1].startsWith('/vendorManagement')) {
          selectedValue = parts[0];
          comment = '';
          files = parts[1];
        } else {
          selectedValue = parts[0];
          comment = parts[1];
          files = '';
        }
      } else {
        // Only one part provided, assign it to selectedValue.
        selectedValue = parts[0] || '';
      }

      this.selectedValue = selectedValue;
      this.comment = comment;
      this.uploadedFiles = files ? files.split(',') : [];
    },
    dateFormatDateRange(classes) {
      return classes;
    },
    handleOptionChange() {

      // Emit event to parent with option ID and whether it requires file

    },
    getMoment(time) {
      moment.locale(this.$i18n.locale);
      return moment(new Date(time)).format('DD MMM YYYY HH:mm');
    },
    checkIfFileUploadIsRequired(selectedValue) {
      const selectedOption = this.configuration.options.find((option) => option.text === selectedValue);

      this.selectedOptionRequiresFileUpload = !!selectedOption?.requireFile;
      this.$emit("option-changed", {
        id: this.input.id,
        requiresFile: !!selectedOption?.requireFile,
      });


    },
    isPhoto(path) {
      return ['jpg', 'png', 'gif', 'jpeg'].includes(path.toLowerCase().split('.').pop());
    },
    dateRangeSelected() {
      let dates =
          moment(this.dateRange.startDate).format('YYYY-MM-DD') +
          ' - ' +
          moment(this.dateRange.endDate).format('YYYY-MM-DD');
      this.$emit('update:modelValue', dates);
    },
    phoneUpdated(event) {
      this.phoneObject = event;
      if (event.isValid) {
        this.$emit('update:modelValue', event.formattedNumber);
      }
    },
    phoneBlur() {
      if (this.phoneObject?.isValid) {
        this.$emit('update:modelValue', this.phoneObject.formattedNumber);
      } else {
        this.$emit('update:modelValue', '');
        this.phoneNumber = '';
      }
    },
    uploadEvent(file, xhr, formData) {
      formData.append('type', 'vendorManagement');
    },
    fileAdded(upload) {
      if (upload.manuallyAdded) {
        //nothing todo
      } else if (upload.status === 'success') {
        let res = JSON.parse(upload.xhr.response);
        let fileUrl = res.path;
        this.uploadedFiles.push(fileUrl);

        // Combine selectValue and uploaded file URLs
        if (this.input.inputType === 'select' || this.configuration.allowFileUpload) {
          const combinedValue = `${this.selectedValue || ''}::::${this.comment || ''}::::${this.uploadedFiles.join(',')}`;
          this.$emit('update:modelValue', combinedValue.trim().replace(/:+$/, ''));
        } else {
          this.$emit('update:modelValue', this.uploadedFiles.join(','));
        }
        this.$emit('file-upload-status', {id: this.input.id, status: true});
      } else {
        this.$refs.fileDropzone.removeFile(upload);
        this.$emit('file-upload-status', {id: this.input.id, status: false});
      }
    },
    fileRemoved(upload) {
      if (upload.status === 'success') {
        let res = JSON.parse(upload.xhr.response);
        let index = this.uploadedFiles.indexOf(res.path);
        this.$emit('file-upload-status', {id: this.input.id, status: false});
        // this.$emit('file-upload-status', { id: this.input.id, status: true });
        if (index > -1) {
          this.uploadedFiles.splice(index, 1);
        }
      }
    },
    checkModelValue() {
      if (this.input.inputType === 'file') {
        if (this.modelValue) {
          let split = this.modelValue.split(',');
          this.uploadedFiles = split;
          split.forEach((filePath) => {
            const fileUrl = `${this.mediaBase}${filePath}`;
            const fileExtension = filePath.split('.').pop().toLowerCase();
            const isImage = ['jpg', 'jpeg', 'png', 'gif'].includes(fileExtension);
//
            // Mock file object
            const mockFile = {
              name: filePath.split('/').pop(),
              size: 1000, // Dummy size; Dropzone doesn't validate this
              type: isImage ? `image/${fileExtension}` : `application/${fileExtension}`,
            };
            this.$refs.fileDropzone.manuallyAddFile(mockFile, fileUrl);
          });
        }
      } else if (this.input.inputType === 'phone') {
        this.phoneNumber = this.modelValue;
      } else if (this.input.inputType === 'select') {
        this.selectedValue = this.modelValue;

        this.syncLocalValues(this.modelValue)
        this.checkIfFileUploadIsRequired(this.modelValue);
      } else if (this.input.inputType === 'daterange' && this.modelValue) {
        let [start, end] = this.modelValue.split(' - ');
        this.dateRange = {
          startDate: moment(start).toDate(),
          endDate: moment(end).toDate(),
        };
      } else if (this.input.inputType === 'date') {
        console.log("checkModelValue çağırıldı:", this.modelValue);

        const parsedDate = moment(this.modelValue, 'DD/MM/YYYY', true); // strict parse

        if (parsedDate.isValid()) {
          const jsDate = parsedDate.toDate();
          if (this.dateSetCount < 2 && (!this.localDate || this.localDate.getTime() !== jsDate.getTime())) {
            this.localDate = jsDate;
            this.dateSetCount++;
            console.log('🟢 Tarix set edildi. Count:', this.dateSetCount);
          }
        } else {
          console.warn('⚠️ Invalid date:', this.modelValue);
        }
      }
    },
  },
  components: {Multiselect, vue2Dropzone, Datepicker, VuePhoneNumberInput, DateRangePicker},
};
</script>

<style lang="scss" scoped>
.blockItem {
  position: relative;
  padding: 10px 15px;

  .actions {
    position: absolute;
    right: 10px;
    top: 10px;
    display: none;
  }

  &.admin {
    border: 1px dashed #e7e6e6;
  }

  &:hover {
    &.admin {
      border-color: #888888;
      box-shadow: 0 0 2px #0b2e13;

      .actions {
        display: block;
      }
    }
  }
}

::v-deep .dropzone {
  min-height: 50px !important;
}

::v-deep .dropzone .dz-default.dz-message {
  width: auto !important;
}

::v-deep .dz-preview:hover .dz-filename {
  text-decoration: line-through; /* Cross out text to indicate delete */
}

::v-deep .dz-preview .dz-filename::after {
  content: "REMOVE FILE";
  display: block;
  font-size: 12px;
  color: #d9534f;
  opacity: 0;
  transition: opacity 0.2s ease;
  text-align: center;
  margin-top: 5px;
}

::v-deep .dz-preview:hover .dz-filename::after {
  opacity: 1;
}

</style>
